import { render, staticRenderFns } from "./MyCarousel.vue?vue&type=template&id=39d07d30&scoped=true"
import script from "./MyCarousel.vue?vue&type=script&lang=js"
export * from "./MyCarousel.vue?vue&type=script&lang=js"
import style0 from "./MyCarousel.vue?vue&type=style&index=0&id=39d07d30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d07d30",
  null
  
)

export default component.exports